export default __webpack_public_path__ + "static/media/crest.e47d2775.svg";